/**
 * Which version of the API this codebase speaks.
 *
 * Here, and shared, because more than one thing has to agree on it: the server
 * declares it, the web client prefixes its requests with it, the importer
 * prefixes the calls it makes back to the API, and the generated document has
 * to print the address that actually works. Written down four times, three of
 * them stay right and one goes quietly stale — which is exactly what happened
 * the first time this moved, and the importer spent a run getting 404s for
 * routes that were there all along.
 */
export const API_VERSION = '1'

/** The path segment: `v1`. Nest's URI versioning prepends the `v` itself. */
export const API_VERSION_PREFIX = `v${API_VERSION}`
